module.exports = __webpack_public_path__ + "media/newstyle/images/cta-desktop-en-f4a028331995d41ed2116aae2d89c6db.png";